import {FigmaCanvas} from "@/includes/fig-parser/models/figma-canvas";

export class FigmaRootContainer {
  thumbnail = '';

  /**
   * @type {FigmaCanvas[]}
   */
  tree = [];
  
  constructor(data) {
    this.thumbnail = data.thumbnail;
    this.tree = this._mapTree(data.tree);
  }
  
  _mapTree(tree) {
    return tree.map(canvas => {
      return new FigmaCanvas(canvas);
    });
  }
}
